/* ==========================================================================
   Satjeevan — Brand Footer JS (sj-brand-footer.js)

   Mobile-only accordion behaviour for footer link columns (≤ 480px, matches
   the CSS tier in sj-brand-footer.css):
     - Columns collapse to one per row; tapping a column's heading row
       expands it and collapses any other open column.
     - All columns start collapsed.
     - Columns can be chained into a group (see the "Merge with previous
       column" block setting, e.g. a long Categories menu split across
       several columns). Only the first column in a group (the "leader",
       marked with [data-sj-bf-leader]) is independently clickable — the
       rest ([data-sj-bf-group] sharing its group id) expand and collapse
       together with it.
   At 481px and above, columns stay fully expanded and their toggle is
   inert — matches the pre-accordion footer markup/behaviour exactly.
   ========================================================================== */

(function () {
  'use strict';

  var INIT_ATTR = 'data-sj-bf-init';
  var MOBILE_QUERY = '(max-width: 480px)';

  function initGrid(grid) {
    if (grid.hasAttribute(INIT_ATTR)) return;
    grid.setAttribute(INIT_ATTR, '1');

    var columns = Array.prototype.slice.call(grid.querySelectorAll('[data-sj-bf-col]'));
    if (!columns.length) return;

    var groups = [];
    var groupsById = {};
    columns.forEach(function (details) {
      var groupId = details.getAttribute('data-sj-bf-group') || details;
      var group = groupsById[groupId];
      if (!group) {
        group = { columns: [], leader: null };
        groupsById[groupId] = group;
        groups.push(group);
      }
      group.columns.push(details);
      if (details.hasAttribute('data-sj-bf-leader')) group.leader = details;
    });

    var mql = window.matchMedia(MOBILE_QUERY);

    function isMobile() {
      return mql.matches;
    }

    function setGroupOpen(group, open) {
      group.columns.forEach(function (details) {
        details.open = open;
      });
    }

    function syncState() {
      var mobile = isMobile();
      groups.forEach(function (group) {
        setGroupOpen(group, !mobile);
        var leaderSummary = group.leader && group.leader.querySelector(':scope > summary');
        if (leaderSummary) leaderSummary.tabIndex = mobile ? 0 : -1;
      });
    }

    groups.forEach(function (group) {
      group.columns.forEach(function (details) {
        var summary = details.querySelector(':scope > summary');
        if (!summary) return;
        var isLeader = details === group.leader;

        // Only the group leader is independently interactive on mobile;
        // followers always mirror it and are never toggled on their own.
        summary.addEventListener('click', function (event) {
          if (!isMobile() || !isLeader) {
            event.preventDefault();
          }
        });

        if (isLeader) {
          details.addEventListener('toggle', function () {
            if (!isMobile()) return;
            setGroupOpen(group, details.open);
            if (details.open) {
              groups.forEach(function (other) {
                if (other !== group) setGroupOpen(other, false);
              });
            }
          });
        }
      });
    });

    syncState();

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncState);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(syncState);
    }
  }

  function init() {
    document.querySelectorAll('[data-sj-bf-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', init);
})();
